'use strict'

export function emailService (http) {
	return {
		sendContactForm: function (contact) {

			const params = {
				to: 'ops@glarus.com.mx',
				subject: 'Contact request from glarus.com.mx'
			}

			return http.jsonrpc(
				'/rpc/public/email',
				'sendContactForm',
				[params, contact]
			).then(function (resp) {
				return resp.result
			})
		}
	}
}
